import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/list`;

export const ROUTE: RouteDefinition = `${baseRoute}/list`;

export const URL = (): RouteDefinition => `${baseRoute}/list`;
